<div class="cancel-payment m-3 m-md-0 mt-5">
    <button
        matButton="outlined"
        id="cancel-payment-button"
        appMatStrokedButtonBorder
        (click)="calcelPayment()"
        [color]="isEmptyCart ? 'primary' : 'error'"
    >
        @if (isEmptyCart) {
            <mat-icon color="primary">search</mat-icon>
        }
        {{ isEmptyCart ? 'NEW SEARCH' : 'CANCEL PAYMENT' }}
    </button>
</div>
